import React, { useEffect } from "react";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Typography,
    Form,
    Col,
    Select,
    DatePicker,
    Divider,
    Space,
    Descriptions,
    Button,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { SearchOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import { labelConfig } from "../../../../group.config";

const { Title } = Typography;

const DetailForm = (props) => {
    const {
        onSearch,
        currencyData,
        displayFields,
        groupInfo,
        showDetailsForm,
        handleSearchInTable,
        onFinish,
        form,
        onChangeProduct,
        productOptions,
        fieldOfficerData,
    } = props;
    const dateFormat = 'YYYY/MM/DD';

    useEffect(() => {
        defaultDate()
    }, [])

    const defaultDate = () => {
        form.setFieldsValue({
            submittedOnDate: dayjs(),
        })
    }

    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };

    const items = [
        {
            label: labelConfig.customerType,
            children: groupInfo ? groupInfo.entityType : "-",
        },
        {
            label: labelConfig.customerName,
            children: groupInfo ? groupInfo.entityName : "-",
        },
        {
            label: labelConfig.mobileNumber,
            children: groupInfo ? groupInfo.entityMobileNo : "-",
        },
        {
            label: labelConfig.customerNumber,
            children: groupInfo ? groupInfo.entityAccountNo : "-",
        },
    ];

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
        >
            <Row>
                <Divider orientation="left" orientationMargin="0">
                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                        {labelConfig.productInfo}
                    </Title>
                </Divider>
                <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                        label={labelConfig.product}
                        name="productId"
                        rules={[
                            {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.product),
                            },
                        ]}
                    >
                        <Select
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase() ?? "").includes(
                                    input?.toLowerCase()
                                )
                            }
                            placeholder={BOM.handlePlaceholderMsg(
                                labelConfig.product,
                                "select"
                            )}
                            options={productOptions}
                            showSearch
                            onChange={onChangeProduct}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {showDetailsForm && (
                <>
                    <Row>
                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {labelConfig.generalInfo}
                            </Title>
                        </Divider>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.submittedOn}
                                name="submittedOnDate"
                                rules={[
                                    {
                                        required: true,
                                        message: BOM.CheckReqFld(labelConfig.submittedOn),
                                    },
                                ]}
                            >
                                <DatePicker
                                    disabledDate={disabledAfterCurrentDate}
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.submittedDate,
                                        "select"
                                    )}
                                    style={{ width: "100%", height: 32.5 }}
                                    format={dateFormat}

                                />
                            </Form.Item>
                        </Col>

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.accountOfficer}
                                name="fieldOfficerId"
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.accountOfficer,
                                        "select"
                                    )}
                                    options={fieldOfficerData}
                                    showSearch
                                    allowClear
                                />
                            </Form.Item>
                        </Col>

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                label={labelConfig.externalID}
                                rules={[
                                    {
                                        required: true,
                                        message: BOM.CheckReqFld(labelConfig.externalID),
                                    },
                                ]}
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.externalID)}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}
        </Form>
    );
};

export default DetailForm;
